import React, { useState } from 'react';
import axios from 'axios';
import './Registro.css';
import { useNavigate } from 'react-router-dom';

const Registro = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    nacimiento: '',
    celular: '',
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("/api/usuarios/registrar", formData);
      alert("Usuario registrado correctamente");
      navigate("/");
    } catch (error) {
       console.error(error);
      const mensaje =
        error.response?.data?.error ||
        "No se pudo registrar el usuario";
        alert(mensaje);
    }
  };

  return (
  <div className="registro-container">

    <div className="registro-card">

      <div className="registro-header">
        <h1>Crear Cuenta</h1>
        <p>
          Únete a la comunidad oficial de Unturned Roleplay
        </p>
      </div>

      <form onSubmit={handleSubmit}>

        <div className="registro-grid">

          <div className="form-group">
            <label>Nombre</label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Apellido</label>
            <input
              type="text"
              name="apellido"
              value={formData.apellido}
              onChange={handleChange}
              required
            />
          </div>

        </div>

        <div className="form-group">
          <label>Fecha de nacimiento</label>
          <input
            type="date"
            name="nacimiento"
            value={formData.nacimiento}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Celular</label>
          <input
            type="tel"
            name="celular"
            value={formData.celular}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Correo electrónico</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Contraseña</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="btn-registrar">
          Crear cuenta
        </button>

      </form>

    </div>

  </div>
);
};

export default Registro;